<noda-articles-banner [article]="article()" />
@if (showAuthors()) {
  <noda-article-author
    [articleModified]="article().updatedAt"
    [author]="author()"
    [reviewer]="reviewer()"
  />
}
@if (caseInfo()) {
  <noda-articles-case-info [caseInfo]="caseInfo()" />
}
